import React from 'react';
import {
  Button, Icon,
} from '@gluestack-ui/themed';

const NavButton = ({
  icon, active, onPress,
}) => (
  <Button
    onPress={onPress}
    bg={active ? '$bgHover' : 'transparent'}
    variant="link"
    size="lg"
    p="$2.5"
  >
    <Icon as={icon} size="lg" color={active ? '$brandStrong' : '$textSubtle'} />
  </Button>
);

export default NavButton;
